import { blue } from "@mui/material";
import logo from "../images/logo.png";
import rpm1 from "../images/carepro.jpg";
function Termsandcondition() {
  return (
    <>
       <div className="col-xl-12 mx-xl-auto" style={{ padding: "20px", backgroundColor: "white" }}>
        <div className="card card-raised mb-3">
          <div className="card-body p-4">
            {/* Blue Header Box with Border & Margin */}
            <div
              style={{
                backgroundColor: "#2e7faeff",
                color: "white",
                padding: "15px",
                textAlign: "center",
                position: "relative",
                border: "2px solid white",
                
                marginBottom: "20px",
                
              }}
            >
              {/* Logo on Left */}
              <img
                 src="/careconnect.jpg"

                alt="Logo"
                style={{
                  height: "50px",
                  position: "absolute",
                  left: "20px",
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              />
              {/* Centered Privacy Policy Title */}
              <h2 style={{ margin: 0, fontWeight: "normal" }}>Terms & Conditions</h2>
            </div>
            <h4>1. INTRODUCTION</h4>
          
              Welcome to StellarRCM Private Limited! These Terms and Conditions
              ("Terms") govern your use of our website located at
              www.stellarrcm.com and our services. Please read these Terms
              carefully. By accessing our site or using our services, you agree
              to be bound by these Terms and all terms incorporated by
              reference. If you do not agree to all of these terms, do not use
              our site or services.
           
            <h4> 2. SERVICES </h4>
           
              We provide various IT products and services through our website.
              In order to use these services, you may be required to provide
              personal details or other information.
            
            <h4> 3. USER OBLIGATIONS</h4>
           
              By using this website and our services, you warrant that all data
              provided by you is accurate and up-to-date. Use of personal
              information submitted to or via the Site is governed by our
              Privacy Policy.
            
            <h4> 4. INTELLECTUAL PROPERTY</h4>
            
              The Company owns all intellectual property rights in the website
              and in the material published on it. These works are protected by
              copyright laws worldwide. All such rights are reserved.
           
            <h4> 5. LIMITATION OF LIABILITY</h4>
           
              Our liability for direct losses arising out of our negligence,
              breach of contract or any other cause of action arising out of or
              in connection with these Terms shall be limited to the total price
              of your Order. In no event shall we be liable for any loss of
              profits, goodwill, loss of business, loss of data or any other
              indirect or consequential loss or damage whatsoever.
           
            <h4> 6. CHANGES TO TERMS AND CONDITIONS</h4>
           
              We reserve the right, at our discretion, to modify these Terms at
              any time. Changes will be posted on the website with a new
              effective date. Your continued use of our Services following the
              posting of changes will mean you accept those changes.
           
            <h4> 7. GOVERNING LAWS AND JURISDICTION </h4>
            
              These Terms are governed by the laws of India. Any disputes
              arising in connection with these terms shall be subject to the
              exclusive jurisdiction of the Courts of India.
            
            <h4>8. CONTACT US</h4>
           
              If you have any questions about these Terms, please contact us at:
              support@stellarrcm.com
            
          </div>
        </div>{" "}
      </div>
    </>
  );
}
export default Termsandcondition;
